// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"573":"ab3b3769","4505":"ab3b3769"}[chunkId] + ".chunk.css";
};